
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Loader2, Cpu, AlertCircle } from 'lucide-react';

interface AgentInitializationStateProps {
  loading: boolean;
  error?: Error | null;
  onInitialize?: () => void;
}

const AgentInitializationState: React.FC<AgentInitializationStateProps> = ({
  loading,
  error,
  onInitialize
}) => {
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>Initialize AI Agent</CardTitle>
        <CardDescription>
          The AI agent system needs to be initialized before use
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center justify-center space-y-4 py-8">
        {loading ? (
          <>
            <Loader2 className="h-12 w-12 animate-spin text-primary" />
            <p className="text-center">Initializing AI agent system...</p>
          </>
        ) : error ? (
          <>
            <AlertCircle className="h-12 w-12 text-destructive" />
            <p className="text-center font-medium text-destructive">{error.message}</p>
            {onInitialize && (
              <Button onClick={onInitialize}>
                Retry Initialization
              </Button>
            )}
          </>
        ) : (
          <>
            <Cpu className="h-12 w-12 text-primary" />
            <p className="text-center">The AI agent system is not initialized.</p>
            {onInitialize && (
              <Button onClick={onInitialize}>
                Initialize Now
              </Button>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default AgentInitializationState;
